import React from "react";
import StaffListTable from "./StaffListTable";

const ManageAccess = () => {
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">All users List</h3>
            {/* <div className="col-auto d-flex w-sm-100">
              <Link
                to="/room-booking"
                className="btn btn-dark btn-set-task w-sm-100"
              >
                Room Book
              </Link>
            </div> */}
          </div>
        </div>
        <div className="col-sm-12">
          <div className="">
            <StaffListTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageAccess;
